const formatMoney = (money) => {
    if (!money) {
        return null;
    }

    const currency = money.currency_iso || 'USD';
    return fromMoney(money).toLocaleString('en-US', { style: 'currency', currency });
};

const fromMoney = (money) => {
    if (!money) {
        return 0;
    }

    if (typeof money === 'number') {
        return money;
    }

    const cents = Number(money.cents || 0);
    return (cents / 100.0);
};

const toMoney = (amount) => ({
    cents: Math.round(Number(amount) * 100),
    currency: 'USD',
});

const formatMoneyInput = (money) => {
    if (!money) {
        return '';
    }

    const amount = fromMoney(money);

    if (amount === 0 && (money.cents === undefined || money.cents === null || money.cents === '')) {
        return '';
    }

    return amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const parseMoneyInput = (value) => {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const cleaned = String(value).replace(/[^0-9.]/g, '');
    if (!cleaned || cleaned === '.') {
        return null;
    }

    const amount = Number(cleaned);
    if (Number.isNaN(amount)) {
        return null;
    }

    return toMoney(amount);
};

export {
    formatMoney,
    formatMoneyInput,
    fromMoney,
    parseMoneyInput,
    toMoney,
};
